export const allowedImagesMimeTypes = ['image/jpeg', 'image/png']

export const validateFilesByMimeTypes = (
  files: FileList | null | File[],
  mimeTypes: string[]
) => {
  if (!files) {
    return
  }
  return Array.from(files).every(({ type }) => mimeTypes.includes(type))
}
